import { Injectable } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { AppLoadingService } from '@examdojo/app-state';
import { combineLatest, filter, map, of, startWith, switchMap, takeWhile, timer } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RoutingLoadingService {
  constructor(
    private readonly router: Router,
    private readonly appLoadingService: AppLoadingService,
  ) {}

  readonly isRoutingLoading$ = this.router.events.pipe(
    map((event) => {
      if (event instanceof NavigationStart) {
        return true;
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        return false;
      }

      return null;
    }),
    filter((isLoading) => isLoading !== null),
    startWith(true),
  );

  readonly isInitialRoutingLoading$ = this.isRoutingLoading$.pipe(
    takeWhile(
      Boolean,
      // Include the first `false` value
      true,
    ),
  );

  readonly showFullScreenLoader$ = combineLatest([
    this.appLoadingService.isLoading$,
    this.isInitialRoutingLoading$,
  ]).pipe(map(([appLoading, routingLoading]) => appLoading || routingLoading));

  readonly showLoadingBar$ = this.isRoutingLoading$.pipe(
    switchMap((isLoading) => {
      if (isLoading) {
        return timer(50).pipe(
          map(() => isLoading),
          startWith(false),
        );
      }
      return of(false);
    }),
  );
}
